import { Box, Card, Divider, Grid, IconButton, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  callAPI,
  clearRequest,
  handleApiError,
  IsSmallScreen,
  Method,
  updateMainHeader
} from "../../commonFunctions/CommonFunctions";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSButton from "../../Components/Button/WSButton";
import WSDateField from "../../Components/DateField/WSDateField";
import { HeaderList, IHeaderListActions } from "../../Components/Header/HeaderList";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../Components/Select/WSSelect";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField, {
  CurrencyType,
  TextType
} from "../../Components/TextBox/WSTextBox";
import { WSView } from "../../Components/View/WSView";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import config from "../../Config/clientConfig.json";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const Estimation: React.FC<any> = React.memo((props) => {
  const { id, estId } = useParams();
  const [loading, setLoading] = useState(false)
  const [termsAndConditions, setTermsAndConditions] = useState<any>()
  const paymentTermsDefault: any = [
    {
      percentage: 30,
      description: "of total value of work on order confirmation."
    },
    {
      percentage: 60,
      description:
        "of total value of work on delivery of material to site."
    },
    {
      percentage: 10,
      description: "balance after completion of work."
    }
  ]
  const { control, register, handleSubmit, setValue, watch, getValues } =
    useForm({
      defaultValues: {
        ownerId: localStorage.getItem("UserId"),
        customerName: "",
        subject: "",
        date: "",
        expiredate: "",
        address: "",
        stage: config.stageConfig.staticOptionData[0].value,
        discount: "",
        adjustments: "",
        termsAndConditions: "",
        remarks: "",
        leadId: "",
        items: [
          { productId: "", quantity: "", unit: "", unitPrice: "", total: "", isIncluded: true, isPolish: "2" }
        ],
        itemsExcluded: [
          { productId: "", quantity: "", unit: "", unitPrice: "", total: "", isIncluded: false }
        ],
        paymentTerms: [
          {
            percentage: 30,
            description: "of total value of work on order confirmation."
          },
          {
            percentage: 60,
            description:
              "of total value of work on delivery of material to site."
          },
          {
            percentage: 10,
            description: "balance after completion of work."
          }
        ]
      }
    });
  const { fields: itemFields, append: itemAppend, remove: itemRemove, replace: itemReplace } = useFieldArray({
    name: "items",
    control
  });
  const { fields: itemExcludedFields, append: itemExcludedAppend, remove: itemExcludedRemove, replace: itemExcludedReplace } = useFieldArray({
    name: "itemsExcluded",
    control
  });
  const {
    fields: paymentTerms,
    append: paymentAppend,
    remove: paymentRemove,
    replace: paymentReplace
  } = useFieldArray({
    name: "paymentTerms",
    control
  });
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const isMobile = IsSmallScreen()
  const [products, setProducts] = useState<any>([]);
  const [lead, setLead] = useState<any>();
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    updateMainHeader(id ? "Edit" : 'Add');

    breadCrumbsStore.updateBreadCrumbs([
      { "Contacts": "/contacts/list" },
      { [id ? "View" : 'Add']: `/contacts/${id}/estimations` },
      { "Estimation": "" },

    ]);
  });
  useEffect(() => {
    if (!estId) {
      setValue('subject', `This is in reference to personal discussion our company representative had with you regarding the paving blocks at your site. We sincerely thank you for the opportunity given to us to quote for the following work and look forward to receiving your valued order.`)
    }
    async function loadTerms() {
      try {
        const response: any = await callAPI("Termsandcondition", Method.GET);
        const terms: any = response?.data || [];

        const numberedString: string = terms
          .flatMap((item: any) => JSON.parse(item.conditions))
          .map((text: string) => `• ${text}`)
          .join("\n");
        console.log("numbered staring", numberedString);
        // ✅ set the value *inside* the function
        setValue("termsAndConditions", numberedString);
        setTermsAndConditions(numberedString)
      } catch (err) {
        console.error("Failed to load terms", err);
      }


    }
    loadTerms()
  }, [])
  // useEffect(() => {
  //   if (!estId && termsAndConditions) {
  //    setValue("termsAndConditions", termsAndConditions);
  //   }
  // }, [termsAndConditions])
  useEffect(() => {
    calculateTotal(subtotal);
  }, [subtotal, watch("discount"), watch("adjustments")]);

  const calculateTotal = (newSubtotal: number) => {
    const discount = parseFloat(watch("discount")) || 0;
    const adjustments = parseFloat(watch("adjustments")) || 0;
    const newTotal = newSubtotal - discount + adjustments;
    setTotal(newTotal);
  };

  // Fetch product details on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response: any = await callAPI("products", Method.GET);
        if (response) {
          setProducts(response.data);
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response: any = await callAPI("leads", Method.GET, null, id);
        if (response) {
          setLead(response);
          setValue("ownerId", response?.ownerId);
          setValue(
            "customerName",
            `${response?.firstName ?? ""} ${response?.lastName ?? ""}`.trim()
          );

          setValue(
            "address",
            [
              response?.city,
              response?.state,
              response?.zipCode,
              response?.country,
            ]
              .filter(Boolean)
              .join(", ")
          );
          setValue("stage", 'New');
        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    fetchLeads();
  }, []);

  useEffect(() => {
    const fetchEstimate = async () => {
      try {
        const response: any = await callAPI("estimates", Method.GET, {}, estId);
        console.log('response from estimage', response.data)

        if (response?.data) {
          // Set main form values
          setValue("ownerId", response.data.ownerId);
          setValue("customerName", response.data.customerName);
          setValue("address", response.data.address);
          setValue("subject", response.data.subject);
          setValue("stage", response.data.stage);
          setValue("discount", response.data.discount);
          setValue("adjustments", response.data.adjustments);
          if (response.data.termsAndConditions != "") {
            setValue("termsAndConditions", response.data.termsAndConditions);
          }
          else { setValue("termsAndConditions", termsAndConditions); }

          setValue("remarks", response.data.remarks);
          setValue("leadId", response.data.leadId);

          // Format dates
          setValue("date", dayjs(response.data.date).format("MM-DD-YYYY"));
          setValue(
            "expiredate",
            dayjs(response.data.validTill).format("MM-DD-YYYY")
          );

          setSubtotal(response.data.subtotal);
          setTotal(response.data.grandTotal);

          // Populate items
          // if (response.data.estimateItems?.length) {
          //   const formattedItems = response.data.estimateItems.map(
          //     (item: any) => ({
          //       productId: item.productId,
          //       quantity: item.quantity.toString(),
          //       unit: item.unit,
          //       unitPrice: item.unitPrice.toString()
          //     })
          //   );

          //   replace(formattedItems); // Updates useFieldArray fields
          // }
          if (response.data.estimateItems?.length) {
            const formattedItems = response.data.estimateItems
              .filter((item: any) => item.isIncluded === true) // ✅ keep only included items
              .map((item: any) => ({
                productId: item.productId,
                quantity: item?.quantity?.toString(),
                unit: item.unit,
                unitPrice: item?.unitPrice?.toString(),
                isPolish: item?.isPolish?.toString()
              }));
            itemReplace(formattedItems);
            const formattedItemsExcluded = response.data.estimateItems
              .filter((item: any) => item.isIncluded === false) // ✅ keep only included items
              .map((item: any) => ({
                productId: item.productId,
                quantity: item?.quantity?.toString(),
                unit: item.unit,
                unitPrice: item?.unitPrice?.toString()
              }));
            // Updates useFieldArray fields
            itemExcludedReplace(formattedItemsExcluded);
            const formattedPaymentTerms = response.data.paymentTerms
              .map((item: any) => ({
                percentage: item.percentage,
                description: item.description,

              }));
            paymentReplace(formattedPaymentTerms?.length > 0 ? formattedPaymentTerms : paymentTermsDefault)
          }

        }
      } catch (error) {
        showMessage("Something went wrong. Please try again.", "error");
      }
    };

    if (estId) fetchEstimate();
  }, [estId, setValue, itemReplace]);

  const handleData = async (data: any, isPrint = false) => {
    try {
      const items = data.items.map((i: any) => ({ ...i, isIncluded: true }));
      const itemsExcluded = data.itemsExcluded.map((i: any) => ({ ...i, isIncluded: false }));
      let productArray: any = []
      if (itemsExcluded[0]?.productId !== undefined && itemsExcluded[0]?.productId !== "") {
        productArray = [...items, ...itemsExcluded];
      }
      else {
        productArray = [...items]
      }

      const paymentTermsValues = getValues("paymentTerms");
      const normalizedProductArray = productArray.map((item: any) => ({
        ...item,
        quantity: item.quantity ? Number(item.quantity) : undefined,
        unitPrice: item.unitPrice ? Number(item.unitPrice) : undefined,
        isPolish: (() => {
          if (item.isPolish === '2' || item.isPolish === 2) return '2';
          if (item.isPolish === '1' || item.isPolish === 1 || item.isPolish === true) return '1';
          return '0';
        })(),
      }));
      let request = {
        ownerId: localStorage.getItem("UserId"),
        customerName: data?.customerName || "",
        address: data?.address || "",
        subject: data?.subject || "",
        stage: data?.stage || "New",
        date: dayjs(data.date).format("YYYY-MM-DDTHH:mm:ss.SSS"),
        validTill: dayjs(data.expiredate).format("YYYY-MM-DDTHH:mm:ss.SSS"),
        termsAndConditions: data?.termsAndConditions || "",
        remarks: data?.remarks || "",
        leadId: id || "",
        subtotal: Number(subtotal) || 0,
        discount: Number(data?.discount) || 0,
        adjustments: Number(data?.adjustments) || 0,
        grandTotal: Number(total) || 0,
        items: normalizedProductArray || [],
        paymentTerms: paymentTermsValues,
      };
      const newRequest = clearRequest(request);
      setLoading(true)

      let response: any;

      if (estId) {
        response = await callAPI('estimates', Method.PUT, newRequest, estId);
      } else {
        response = await callAPI('estimates', Method.POST, newRequest);
      }

      if (response?.errors) {
        const mess = handleApiError(response);
        showMessage(mess, 'error');
      } else if (response) {
        console.log('response after create estimate',response);
        showMessage(response?.message, response.success === true ? "success" : "error");

        if (response.success === true) {
          if (!isPrint) {
            navigate(`/contacts/${id}/estimations`);
          } else {
            const EstimationId = estId || response?.estimateId;
            if (EstimationId) {
              window.open(`/estimation/print/${EstimationId}`, "_blank");
              setTimeout(() => {
                navigate(`/contacts/${id}/estimations`);
              }, 300);
            }
          }
        }
      }


    } catch (e: any) {
      showMessage(e.error);
    }
    finally {
      setLoading(false)
    }
  };
  const handlePercentageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`paymentTerms.${index}.percentage`, Number(event.target.value));

  };
  const handleProductChange = (index: number, event: any) => {
    const selectedProductId = event.target.value; // Get selected product ID
    const selectedProduct = products.find(
      (p: any) => p.id === selectedProductId
    );
    if (selectedProduct) {
      setValue(`items.${index}.unit`, selectedProduct.unit);
      setValue(`items.${index}.unitPrice`, selectedProduct.unitPrice);

      setValue(`items.${index}.quantity`, "1"); // Convert 1 to string
      setValue(
        `items.${index}.total`,
        (selectedProduct.unitPrice * 1).toString()
      ); // Convert total to string

      // Recalculate Subtotal
      recalculateSubtotal();
    }
  };
  const handleProductChangeExcluded = (index: number, event: any) => {
    const selectedProductId = event.target.value; // Get selected product ID
    const selectedProduct = products.find(
      (p: any) => p.id === selectedProductId
    );
    if (selectedProduct) {
      setValue(`itemsExcluded.${index}.unit`, selectedProduct.unit);
      setValue(`itemsExcluded.${index}.unitPrice`, selectedProduct.unitPrice);

      setValue(`itemsExcluded.${index}.quantity`, "1"); // Convert 1 to string
      setValue(
        `itemsExcluded.${index}.total`,
        (selectedProduct.unitPrice * 1).toString()
      ); // Convert total to string

      // Recalculate Subtotal
      recalculateSubtotal();
    }
  };
  const recalculateSubtotal = () => {
    const updatedItems = getValues("items") || [];
    let newSubtotal = updatedItems.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity) || 1;
      const unitPrice = parseFloat(item.unitPrice) || 0;
      return sum + quantity * unitPrice;
    }, 0);
    const updateditemsExcluded = getValues("itemsExcluded") || [];
    let newitemsExcludedSubtotal = updateditemsExcluded.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity) || 1;
      const unitPrice = parseFloat(item.unitPrice) || 0;
      return sum + quantity * unitPrice;
    }, 0);
    setSubtotal(newSubtotal + newitemsExcludedSubtotal);
    calculateTotal(newSubtotal + newitemsExcludedSubtotal);
  };

  const handleQuantityChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`items.${index}.quantity`, event.target.value);

    setValue(`items.${index}.total`, total.toString()); // Convert to string

    // Recalculate Subtotal
    recalculateSubtotal();
  };

  const handleUnitPriceChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`items.${index}.unitPrice`, event.target.value);
    setValue(`items.${index}.total`, total.toString()); // Convert to string

    // Recalculate Subtotal
    recalculateSubtotal();
  };
  const handleQuantityChangeExcluded = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`itemsExcluded.${index}.quantity`, event.target.value);
    setValue(`itemsExcluded.${index}.total`, total.toString()); // Convert to string

    // Recalculate Subtotal
    recalculateSubtotal();
  };
  const handleUnitPriceChangeExcluded = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValue(`itemsExcluded.${index}.unitPrice`, event.target.value);
    setValue(`itemsExcluded.${index}.total`, total.toString()); // Convert to string

    // Recalculate Subtotal
    recalculateSubtotal();
  };
  const handleCancelClick = () => {
    navigate(`/contacts/${id}/estimations`)
  };

  const actions: IHeaderListActions[] = [
    {
      type: 'button',
      text: 'Cancel',
      size: 'medium',
      onClick: handleCancelClick,
      variant: 'outlined',
      color: 'primary',
    },
    {
      type: 'button',
      text: 'Save',
      loading: loading,
      size: 'medium',
      onClick: handleSubmit((data) => handleData(data)),
      buttonType: 'submit',
      variant: 'outlined',
      color: 'primary',
    },
    {
      type: 'button',
      text: 'Save And Print',
      loading: loading,
      size: 'medium',
      onClick: handleSubmit((data) => handleData(data, true)),
      buttonType: 'submit',
      variant: 'outlined',
      color: 'primary',
    },
  ];

  return (
    <Grid container p={2} spacing={2}>
      <Grid item xs={12}>
        <HeaderList
          title={estId ? "Update Estimation" : "Create New Estimation"}
          type="card"
          actions={actions}
          isBackButton
          url={`/contact/edit/${id}`}
        />

        <form onSubmit={handleSubmit((data) => handleData(data))}>
          {/* Main Estimation Details Card */}
          <Card sx={{ borderRadius: "12px", padding: 3, mt: 2, boxShadow: 2 }}>
            <Typography variant="h6" sx={{ mb: 3, color: "primary.main", fontWeight: 600 }}>
              Estimation Details
            </Typography>

            <Grid container spacing={3}>
              {/* Customer & Stage Section */}
              <Grid item xs={12} sm={6}>
                <WSTextField
                  label="Customer Name *"
                  rules={{ required: true }}
                  id="customerName"
                  name="customerName"
                  disabled
                  control={control}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSSelectField
                  rules={{ required: false }}
                  {...register("stage")}
                  id="stage"
                  control={control}
                  defaultValue="New"
                  label="Stage"
                  name="stage"
                  options={config.stageConfig.staticOptionData}

                />
              </Grid>

              {/* Address Section */}
              <Grid item xs={12}>
                <WSTextField
                  label="Address *"
                  id="address"
                  name="address"
                  control={control}
                  rules={{ required: true }}

                />
              </Grid>

              {/* Date Section */}
              <Grid item xs={12} sm={6}>
                <WSDateField
                  id="date"
                  name="date"
                  label="Date *"
                  control={control}
                  rules={{ required: true }}

                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <WSDateField
                  id="expiredate"
                  name="expiredate"
                  label="Expiry Date *"
                  control={control}
                  rules={{ required: true }}

                />
              </Grid>

              {/* Subject */}
              <Grid item xs={12}>
                <WSTextAreaField
                  label="Subject *"
                  id="subject"
                  name="subject"
                  control={control}
                  rules={{ required: true }}
                  rows={2}

                />
              </Grid>
            </Grid>
          </Card>

          {/* Included Items Section */}
          <Card sx={{ borderRadius: "12px", padding: 3, mt: 3, boxShadow: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ color: "success.main", fontWeight: 600 }}>
                Included Items
              </Typography>
              <WSButton
                id="addButton"
                label="+ Add Included Item"
                variant="outlined"
                size="small"
                color="success"
                startIcon={<WSIcons.AddIcon />}
                onClick={() =>
                  itemAppend({
                    productId: "",
                    quantity: "",
                    unit: "",
                    unitPrice: "",
                    total: "",
                    isIncluded: true,
                    isPolish: "2"
                  })
                }
              />
            </Box>

            {itemFields.map((row: any, index: any) => (
              <Card key={row.id} sx={{ p: 2, mb: 2, backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0' }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={3}>
                    <WSSelectField
                      label="Product *"
                      rules={{ required: true }}
                      {...register(`items.${index}.productId`)}
                      id={`selectProduct-${index}`}
                      control={control}
                      options={products.map((product: any) => ({
                        label: product.name,
                        value: product.id
                      }))}
                      onChange={(event) => handleProductChange(index, event)}
                      inlineSearch
                    />
                  </Grid>

                  <Grid item xs={6} sm={1.5}>
                    <WSTextField
                      label="Unit"
                      {...register(`items.${index}.unit`)}
                      id={`unit-${index}`}
                      control={control}
                      disabled

                    />
                  </Grid>

                  <Grid item xs={6} sm={1.5}>
                    <WSTextField
                      label="Unit Price"
                      {...register(`items.${index}.unitPrice`, {
                        onChange: (event) => handleUnitPriceChange(index, event)
                      })}
                      id={`unitPrice-${index}`}
                      control={control}
                      type={TextType.Currency}
                      currency={CurrencyType.Rupee}

                    />
                  </Grid>

                  <Grid item xs={6} sm={1.5}>
                    <WSTextField
                      id={`quantity-${index}`}
                      label="Quantity"
                      {...register(`items.${index}.quantity`, {
                        onChange: (event) => handleQuantityChange(index, event)
                      })}
                      control={control}
                      type={TextType.Number}

                    />
                  </Grid>

                  <Grid item xs={6} sm={2}>
                    <WSSelectField
                      label="Polish"
                      rules={{ required: true }}
                      {...register(`items.${index}.isPolish`)}
                      id={`isPolish-${index}`}
                      control={control}
                      options={config.ploishConfig.staticOptionData}
                      onChange={(event) => handleProductChange(index, event)}

                    />
                  </Grid>

                  <Grid item xs={6} sm={1.5}>
                    <Box sx={{
                      p: 1,
                      backgroundColor: 'white',
                      borderRadius: 1,
                      border: '1px solid #e0e0e0',
                      textAlign: 'center'
                    }}>
                      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'success.main' }}>
                        ₹{Number(watch(`items.${index}.unitPrice`) || 0) * Number(watch(`items.${index}.quantity`) || 0)}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={1}>
                    <WSHiddenField name={`items.${index}.isIncluded`} control={control} defaultValue={true} />
                    <IconButton
                      onClick={() => {
                        itemRemove(index);
                        recalculateSubtotal();
                      }}
                      sx={{ color: "error.main" }}
                      size="small"
                    >
                      <WSIcons.DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Card>
            ))}
          </Card>

          {/* Excluded Items Section */}
          <Card sx={{ borderRadius: "12px", padding: 3, mt: 3, boxShadow: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ color: "error.main", fontWeight: 600 }}>
                Excluded Items
              </Typography>
              <WSButton
                id="addExcludedButton"
                label="+ Add Excluded Item"
                variant="outlined"
                size="small"
                color="error"
                startIcon={<WSIcons.AddIcon />}
                onClick={() =>
                  itemExcludedAppend({
                    productId: "",
                    quantity: "",
                    unit: "",
                    unitPrice: "",
                    total: "",
                    isIncluded: false
                  })
                }
              />
            </Box>

            {itemExcludedFields.map((row, index) => (
              <Card key={row.id} sx={{ p: 2, mb: 2, backgroundColor: '#fff5f5', border: '1px solid #ffcdd2' }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={3}>
                    <WSSelectField
                      label="Product"
                      rules={{ required: false }}
                      {...register(`itemsExcluded.${index}.productId`)}
                      id={`itemsExcluded-${index}`}
                      control={control}
                      options={products.map((product: any) => ({
                        label: product.name,
                        value: product.id
                      }))}
                      onChange={(event) => handleProductChangeExcluded(index, event)}
                      inlineSearch
                    />
                  </Grid>

                  <Grid item xs={6} sm={2}>
                    <WSTextField
                      label="Unit"
                      {...register(`itemsExcluded.${index}.unit`)}
                      id={`itemsExcluded-unit-${index}`}
                      control={control}
                      disabled

                    />
                  </Grid>

                  <Grid item xs={6} sm={2}>
                    <WSTextField
                      label="Unit Price"
                      {...register(`itemsExcluded.${index}.unitPrice`, {
                        onChange: (event) => handleUnitPriceChangeExcluded(index, event)
                      })}
                      id={`itemsExcluded-unitPrice-${index}`}
                      control={control}
                      type={TextType.Currency}
                      currency={CurrencyType.Rupee}

                    />
                  </Grid>

                  <Grid item xs={6} sm={2}>
                    <WSTextField
                      id={`itemsExcluded-quantity-${index}`}
                      label="Quantity"
                      {...register(`itemsExcluded.${index}.quantity`, {
                        onChange: (event) => handleQuantityChangeExcluded(index, event)
                      })}
                      control={control}
                      type={TextType.Number}

                    />
                  </Grid>

                  <Grid item xs={6} sm={2}>
                    <Box sx={{
                      p: 1,
                      backgroundColor: 'white',
                      borderRadius: 1,
                      border: '1px solid #ffcdd2',
                      textAlign: 'center'
                    }}>
                      <Typography sx={{ fontSize: '0.875rem', fontWeight: 'bold', color: 'error.main' }}>
                        ₹{Number(watch(`itemsExcluded.${index}.unitPrice`) || 0) * Number(watch(`itemsExcluded.${index}.quantity`) || 0)}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={1}>
                    <WSHiddenField name={`itemsExcluded.${index}.isIncluded`} control={control} defaultValue={false} />
                    <IconButton
                      onClick={() => {
                        itemExcludedRemove(index);
                        recalculateSubtotal();
                      }}
                      sx={{ color: "error.main" }}
                      size="small"
                    >
                      <WSIcons.DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Card>
            ))}
          </Card>

          {/* Payment Terms Section */}
          <Card sx={{ borderRadius: "12px", padding: 3, mt: 3, boxShadow: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h6" sx={{ color: "info.main", fontWeight: 600 }}>
                Payment Terms
              </Typography>
              <WSButton
                id="addPaymentTermButton"
                label="+ Add Payment Term"
                variant="outlined"
                size="small"
                color="info"
                startIcon={<WSIcons.AddIcon />}
                onClick={() =>
                  paymentAppend({
                    percentage: 0,
                    description: ""
                  })
                }
              />
            </Box>

            {paymentTerms.map((row, index) => (
              <Card key={row.id} sx={{ p: 2, mb: 2, backgroundColor: '#f3f5f7', border: '1px solid #e3f2fd' }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={2}>
                    <WSTextField
                      label="Percentage %"
                      {...register(`paymentTerms.${index}.percentage`, {
                        onChange: (event) => handlePercentageChange(index, event)
                      })}
                      id={`paymentTerms-percentage-${index}`}
                      control={control}
                      type={TextType.Number}

                    />
                  </Grid>

                  <Grid item xs={12} sm={9}>
                    <WSTextField
                      label="Description"
                      {...register(`paymentTerms.${index}.description`)}
                      id={`paymentTerms-description-${index}`}
                      control={control}

                    />
                  </Grid>

                  <Grid item xs={12} sm={1}>
                    <IconButton
                      onClick={() => paymentRemove(index)}
                      sx={{ color: "error.main" }}
                      size="small"
                    >
                      <WSIcons.DeleteIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Card>
            ))}
          </Card>

          {/* Terms & Conditions */}
          <Card sx={{ borderRadius: "12px", padding: 3, mt: 3, boxShadow: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, color: "warning.main", fontWeight: 600 }}>
              Terms & Conditions
            </Typography>
            <WSTextAreaField
              id="termsandcondition"
              bulletType="bullet"
              label="Terms and Conditions"
              {...register("termsAndConditions")}
              control={control}
              rows={4}

            />
          </Card>

          {/* Summary Section */}
          <Card sx={{ borderRadius: "12px", padding: 3, mt: 3, boxShadow: 2, backgroundColor: "#f8f9fa" }}>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
              Estimation Summary
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }}>Sub Total</Typography>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "right" }}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 600 }}>₹ {subtotal.toFixed(2)}</Typography>
              </Grid>

              <Grid item xs={8}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }}>Discount</Typography>
              </Grid>
              <Grid item xs={4}>
                <WSTextField
                  id="discount"
                  {...register("discount")}
                  control={control}
                  type={TextType.Number}
                  label={"Discount"}
                  sx={{ textAlign: "right" }}
                />
              </Grid>

              <Grid item xs={8}>
                <Typography sx={{ fontSize: '1rem', fontWeight: 500 }}>Adjustments</Typography>
              </Grid>
              <Grid item xs={4}>
                <WSTextField
                  id="adjustments"
                  {...register("adjustments")}
                  control={control}
                  type={TextType.Number}
                  label={"Adjustments"}
                  sx={{ textAlign: "right" }}
                />
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>

              <Grid item xs={8}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>Total Amount</Typography>
              </Grid>
              <Grid item xs={4} sx={{ textAlign: "right" }}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main" }}>
                  ₹ {total.toFixed(2)}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </form>
      </Grid>
    </Grid>
  );
});
